export default "__VITE_ASSET__CjOeSJ4R__"